<template>
  <div>
    <div class="card" v-loading="working" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">{{token ? 'Create new ' : 'Update'}} password</h4>
        <p v-if="!token" class="category">Please supply your current password and a new password</p>
      </div>
      <div class="card-content">
        <div class="form-horizontal" data-vv-scope="user-form">
          <dynamic-input v-if="!token" label="Username" :readOnly="true" :value="username" :controlSize="9" />
          <dynamic-input v-if="!token" label="Current password" name="password" type="PASSWORD" :validations="{required: true}" v-model="password" :controlSize="9" />
          <dynamic-input label="New password" name="newpassword" type="PASSWORD" :inline="!token" :tooltipPassword="true" :validations="{required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*\-$£])[A-Za-z\d!@#$%^&*\-$£]{6,}$/, min:6, max:256}" v-model="newPassword" :controlSize="9" />
          <dynamic-input label="Confirm new password" name="confirmpassword" type="PASSWORD" :inline="!token" :validations="{required: true, confirmed:newPassword}" v-model="confirmPassword" :controlSize="9" />
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button v-if="!token" @click="$emit('close')" class="btn btn-wd"><span class="btn-label"><i class="fa fa-times"></i></span>Cancel</button>
          <button @click.prevent="updatePassword" class="btn btn-fill btn-wd btn-default pull-right" v-bind:disabled="!savable" v-bind:class="{'btn-disabled': !savable}"><span class="btn-label"><i class="fa fa-floppy-o"></i></span>Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'

  export default {
    name: 'update-password-card',
    components: {
      DynamicInput
    },
    props: {
      username: String,
      token: String
    },
    data () {
      return {
        saving: false,
        password: null,
        newPassword: null,
        confirmPassword: null
      }
    },
    computed: {
      working() {
        return this.saving
      },
      savable() {
        return !this.saving && !this.$validator.errors.any()
      }
    },
    methods: {
      updatePassword() {
        this.$validator.validateAll().then(result => {
          if(result) {
            this.saving = true
            this.doSave()
              .then(response => {
                this.$snotify.success("Your password has been updated.", "Success")
                this.$emit('saved')
                this.saving = false
              })
              .catch(error => {
                console.log(error)
                this.saving = false
                this.$emit('failed')
              })
          }
        })
      },
      doSave() {
        var updateRequest = {
          username: this.username,
          password: this.password,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword
        }
        return this.$api.updatePassword(updateRequest, this.token)
      }
    }
  }
</script>